import { api } from "../helpers/apiHelperV3";
import store from "../store/store";
import { urls } from "./urls";

/**
 * Get prices for a runner
 */
export const getPrices = (runnerId: number): any => {
  const url = urls.data.API_RUNNERS_PRICES(runnerId);
  return api
    .get(url)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

export const getPricesForMultiples = (runnerId: number): any => {
  const url = urls.data.API_RUNNERS_MULTIPLIER_PRICES(runnerId);
  return api
    .get(url)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * Get prices for all bets in bet slip
 */
export const getPricesForRunnersInBetslip = (): any => {
  const betSlipList = store.getState().betSlipListModel.betSlipList;
  const runnerIds = betSlipList.map(bet => bet.markets[0].runners[0].id);
  const url = urls.data.API_RUNNERS_PRICES();
  const params = {
    runnerIds: runnerIds.join(","),
  };

  return api
    .get(url, {
      params: params,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

export const getPricesForMultiplesRunnersInBetslip = (): any => {
  const multiplesBetSlipList =
    store.getState().multiplesBetSlipListModel.multiplesBetSlipList;
  const runnerIds = multiplesBetSlipList.map(bet => bet.runnerId);
  const url = urls.data.API_RUNNERS_MULTIPLIER_PRICES();
  const params = {
    runnerIds: runnerIds.join(","),
  };
  return api
    .get(url, {
      params: params,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

// To allow multiples endpoint to be used for bet builder
// Pass in an array of runnerIds
export const getPricesForMultiplesRunners = (
  runnerIds: number[]
): Promise<any> => {
  const url = urls.data.API_RUNNERS_MULTIPLIER_PRICES();
  const params = {
    runnerIds: runnerIds.join(","),
  };
  return api
    .get(url, {
      params: params,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};
